// extracted by mini-css-extract-plugin
export default {"scriptContainer":"VideoScript_scriptContainer__LzGJy","titleSection":"VideoScript_titleSection__26Hri","contentSection":"VideoScript_contentSection__pZf0J"};